import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';
import { GlobalSearchDialogContent } from 'site-modules/shared/components/inventory/global-search/global-search-dialog-content/global-search-dialog-content';

const drawerClassNames = { drawerContainer: 'h-100 d-flex', drawerContent: 'w-100' };

export const GlobalSearchDrawer = memo(
  ({
    id,
    ariaLabel,
    searchId,
    creativeId,
    query,
    fastMatcherData,
    onInputChange,
    onQueryCancel,
    onSearchFieldKeydown,
    onDrawerClose,
    onLinkClick,
    isFastMatcherLoading,
    isOpen,
    withLlmSearchDisabled,
    isMobile,
    trapFocus,
    restoreFocus,
  }) => (
    <DrawerV2
      isOpen={isOpen}
      toggle={noop}
      side="bottom"
      size="small"
      id={id}
      ariaLabel={ariaLabel}
      noInitialFocus
      classNames={drawerClassNames}
      unmountOnExit
      trapFocus={trapFocus}
      restoreFocus={restoreFocus}
    >
      <GlobalSearchDialogContent
        onDrawerClose={onDrawerClose}
        isMobile={isMobile}
        fastMatcherData={fastMatcherData}
        isFastMatcherLoading={isFastMatcherLoading}
        query={query}
        searchId={searchId}
        withLlmSearchDisabled={withLlmSearchDisabled}
        onInputChange={onInputChange}
        onQueryCancel={onQueryCancel}
        onSearchFieldKeydown={onSearchFieldKeydown}
        creativeId={creativeId}
        onLinkClick={onLinkClick}
      />
    </DrawerV2>
  )
);

GlobalSearchDrawer.propTypes = {
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  searchId: PropTypes.string,
  creativeId: PropTypes.string,
  query: PropTypes.string,
  fastMatcherData: PropTypes.shape({
    delta: PropTypes.string,
    struct: PropTypes.shape({}),
  }),
  onSearchFieldKeydown: PropTypes.func,
  onInputChange: PropTypes.func,
  onQueryCancel: PropTypes.func,
  onDrawerClose: PropTypes.func,
  onLinkClick: PropTypes.func,
  isFastMatcherLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  withLlmSearchDisabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  trapFocus: PropTypes.bool,
  restoreFocus: PropTypes.bool,
};

GlobalSearchDrawer.defaultProps = {
  ariaLabel: '',
  searchId: '',
  creativeId: '',
  query: '',
  fastMatcherData: null,
  onSearchFieldKeydown: noop,
  onLinkClick: noop,
  onInputChange: noop,
  onQueryCancel: noop,
  onDrawerClose: noop,
  isFastMatcherLoading: false,
  isOpen: false,
  withLlmSearchDisabled: false,
  isMobile: false,
  trapFocus: undefined,
  restoreFocus: undefined,
};
